import { QueryParamListBase } from "@shared/models";

export interface FetchErkomListQueryParam extends QueryParamListBase{
  id: number;
  medic: string | null;
  patient: string;
  id_number: string | number;
  product: string;
  establishment: string;
  email: string;
  phone_number: string;
  startDate: string; // ISO
  endDate: string; // ISO
  clinical_status: string | null;
  comertial_status: string | null;
}
